import React, { ComponentProps } from 'react';

import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';

const ClearButton = ({
  variant = Button.VARIANTS.TERTIARY,
  size = Button.SIZES.SMALL,
  onClick,
  ...props
}: ComponentProps<typeof Button>) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <Button variant={variant} size={size} onClick={onClick} {...props}>
      {T.translate('CLEAR')}
    </Button>
  );
};

ClearButton.displayName = 'ClearButton';

export default ClearButton;
